import { render } from "./ChecklistModel.vue?vue&type=template&id=8dd24d4a"
import script from "./ChecklistModel.vue?vue&type=script&lang=js"
export * from "./ChecklistModel.vue?vue&type=script&lang=js"
script.render = render

export default script